import { useState } from "react";
import { PartyPopper } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { confetti } from "@/lib/celebrate";

const COLORS = ["#ffffff", "#fff6d9", "#f3d27a", "#e2bb5c", "#c8962e"];

export const CongratsButton = ({ honor, className = "", onDone }) => {
  const { user } = useAuth();
  const [s, setS] = useState({ congrats: honor.congrats || 0, congratulated: honor.congratulated });
  const [busy, setBusy] = useState(false);
  const self = user?.user_id === honor.user_id;
  const go = async (e) => {
    e.preventDefault(); e.stopPropagation();
    if (s.congratulated || self || busy) return;
    const r = e.currentTarget.getBoundingClientRect();
    setBusy(true);
    try {
      const { data } = await api.post(`/honor/${honor.user_id}/congrats`);
      setS(data);
      onDone?.(data);
      confetti({ x: r.left + r.width / 2, y: r.top, count: 40, spread: 1.2, colors: COLORS });
    } catch (err) { toast.error(formatErr(err)); } finally { setBusy(false); }
  };
  const n = s.congrats;
  const label = self ? `${n} ${n === 1 ? "Glückwunsch" : "Glückwünsche"} für dich` : s.congratulated ? `Gratuliert · ${n}` : `Gratulieren${n ? ` · ${n}` : ""}`;
  return (
    <button type="button" onClick={go} disabled={busy || self || s.congratulated} data-testid={`honor-congrats-${honor.user_id}`} aria-pressed={s.congratulated}
      className={`h-10 px-5 rounded-full inline-flex items-center justify-center gap-2 text-sm font-extrabold whitespace-nowrap active:scale-95 transition-[transform,opacity] ${s.congratulated || self ? "bg-white border border-amber-200 text-[#9a6a12]" : "honor-chip hover:scale-105"} ${className}`}>
      <PartyPopper className="w-4 h-4" /> {label}
    </button>
  );
};
